module.exports = __webpack_public_path__ + "static/media/logo-unid-negro.51e918d5.png";